import { Modal } from "@mui/material";
import React, { useState } from "react";
import { IBatchItemReturn } from "../../model/ItemModel";
import { BatchDefaultAction } from "./components/BatchDefaultAction";
import { BatchFeedback } from "./components/BatchFeedback";

interface IBatchActionModal {
    aprovedFiles: IBatchItemReturn[];
    reprovedFiles: IBatchItemReturn[];
    open: boolean;
    setOpen: (set: boolean) => void;
    refreshFunction: () => void;
}

export type batchActionStates = {
    default: boolean,
    approved: boolean,
    reproved: boolean,
}

export const BatchActionModal : React.FC<IBatchActionModal> = ({
    aprovedFiles,
    reprovedFiles,
    open,
    setOpen,
    refreshFunction
}) => {
    const [value, setValue] = useState(0);
    const [batchModalState, setBatchModalState] = useState<batchActionStates>({
        default: true,
        approved: false,
        reproved: false
    });
    const [] = useState<IBatchItemReturn[]>([]);

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
      setValue(newValue);
    };

    const handleClose = () => {
        setOpen(false);
    }
    
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <>
                { batchModalState.default && !batchModalState.approved &&  !batchModalState.reproved && (
                    <BatchDefaultAction 
                        approvedFiles={aprovedFiles}
                        reprovedFiles={reprovedFiles}
                        handleChange={handleChange}
                        setOpen={setOpen}
                        value={value}
                        setBatchModalState={setBatchModalState}
                        refreshFunction={refreshFunction}
                    />
                ) }

                { batchModalState.approved && !batchModalState.default &&  !batchModalState.reproved && (
                    <BatchFeedback 
                        files={aprovedFiles}
                        handleClose={handleClose}
                        setBatchModalState={setBatchModalState}
                        type="APPROVED"
                    />
                ) }

                { batchModalState.reproved && !batchModalState.approved &&  !batchModalState.default && (
                    <BatchFeedback 
                        files={aprovedFiles}
                        handleClose={handleClose}
                        setBatchModalState={setBatchModalState}
                        type="REPROVED"
                    />
                ) }

            </>
        </Modal>
    )
}
